import { Component, ElementRef, Input, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: "cs-animated-digit",
    templateUrl: "./animated-digit.component.html"
})
export class AnimatedDigitComponent implements AfterViewInit, OnChanges {
    @Input() duration: number;
    @Input() digit: number = null;
    @Input() steps: number;
    @ViewChild("animatedDigit") animatedDigit: ElementRef;

    animateCount() {        
        if (!this.duration) {
            this.duration = 1000;
        }

        if (typeof this.digit === "number" && this.digit >= 0) {
            this.counterFunc(this.digit, this.duration, this.animatedDigit);
        }
        else {            
            this.animatedDigit.nativeElement.textContent = 0;
        }
    }

    counterFunc(endValue: number, durationMs: number, element: any) {
        if (!this.steps) {
            this.steps = 12;
        }

        const stepCount = Math.ceil(durationMs / this.steps);
        const sinValueIncrement = Math.PI / stepCount;

        let currentStep = 0;

        function step() {
            if (currentStep <= stepCount) {
                const progress = Math.sin((currentStep / stepCount) * (Math.PI / 2));
                const currentValue = Math.floor(endValue * progress);

                if (element) {
                    element.nativeElement.textContent = currentValue;
                }

                currentStep++;
                window.requestAnimationFrame(step);
            } else {
                // Final frame: ensure exact endValue is set
                if (element) {
                    element.nativeElement.textContent = endValue;
                }
            }
        }

        step();
    }


    ngAfterViewInit() {
        if (this.digit) {
            this.animateCount();
        }
        else {            
            this.animatedDigit.nativeElement.textContent = 0;
        }
    }

    ngOnChanges(changes: SimpleChanges) {        
        if (changes["digit"] && changes.digit.previousValue != changes.digit.currentValue) {
            this.animateCount();
        }
    }
}